import { gql } from '@apollo/client';

export const GET_TRANSLATIONS = gql`
  query GetDatoContext(
    $locale: SiteLocale!
    $sharedDictionaryLookup: [String!]!
    $extrasDictionaryLookup: [String!]!
    $orderListDictionaryLookup1: [String!]!
    $orderListDictionaryLookup2: [String!]!
    $orderListDictionaryLookup3: [String!]!
    $orderListDictionaryLookup4: [String!]!
    $loggedinDictionaryLookup: [String!]!
  ) {
    orderList1: allMyorderOrderlists(
      locale: $locale
      filter: { key: { in: $orderListDictionaryLookup1 } }
    ) {
      key
      value
    }
    orderList2: allMyorderOrderlists(
      locale: $locale
      filter: { key: { in: $orderListDictionaryLookup2 } }
    ) {
      key
      value
    }
    orderList3: allMyorderOrderlists(
      locale: $locale
      filter: { key: { in: $orderListDictionaryLookup3 } }
    ) {
      key
      value
    }
    orderList4: allMyorderOrderlists(
      locale: $locale
      filter: { key: { in: $orderListDictionaryLookup4 } }
    ) {
      key
      value
    }
    extras: allMyorderExtrasWebshopDictionaries(
      locale: $locale
      filter: { key: { in: $extrasDictionaryLookup } }
    ) {
      key
      value
    }
    loggedin: allLoginDictionaries(
      locale: $locale
      filter: { key: { in: $loggedinDictionaryLookup } }
    ) {
      key
      value
    }

    shared: allSharedDictionaries(
      locale: $locale
      filter: { key: { in: $sharedDictionaryLookup } }
    ) {
      key
      value
    }
  }
`;
